module.exports = __webpack_public_path__ + "static/media/burger-soda.b299d274.svg";